import { render, staticRenderFns } from "./ChoicePanel.vue?vue&type=template&id=2c0a2041&scoped=true"
import script from "./ChoicePanel.vue?vue&type=script&lang=js"
export * from "./ChoicePanel.vue?vue&type=script&lang=js"
import style0 from "./ChoicePanel.vue?vue&type=style&index=0&id=2c0a2041&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a2041",
  null
  
)

export default component.exports